module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"categories":"Kategorien","thereAreCurrentlyNoBookableEvents":"Momentan sind keine buchbaren Seminare vorhanden"},"en":{"thereAreCurrentlyNoBookableEvents":"There are currently no bookable events"}}')
  delete Component.options._Ctor
}
